/**
 * Utility to fetch and parse the Riverside RSS feed
 * Handles XML parsing to extract audio URLs, titles, and metadata.
 */
export const fetchPodcastFeed = async (rssUrl) => {
  try {
    // We use a CORS proxy for the browser environment to access the RSS feed
    const proxyUrl = `https://api.allorigins.win/raw?url=${encodeURIComponent(rssUrl)}`;
    const response = await fetch(proxyUrl);
    const xmlText = await response.text();
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlText, "text/xml");
    const items = xmlDoc.querySelectorAll("item");

    return Array.from(items).map(item => {
      // Extract audio URL from <enclosure> tag
      const enclosure = item.querySelector("enclosure");
      const audioUrl = enclosure ? enclosure.getAttribute("url") : "";

      // Extract Image (from itunes:image or channel image)
      const itunesImage = item.getElementsByTagName("itunes:image")[0];
      const image = itunesImage ? itunesImage.getAttribute("href") : xmlDoc.querySelector("channel > image > url")?.textContent;

      // Extract Duration
      const duration = item.getElementsByTagName("itunes:duration")[0]?.textContent || "00:00";
      
      // Extract GUID for unique identification
      const guid = item.querySelector("guid")?.textContent;

      return {
        title: item.querySelector("title")?.textContent || "Untitled Episode",
        description: item.querySelector("description")?.textContent?.replace(/<[^>]*>?/gm, '').slice(0, 200) + "..." || "",
        pubDate: new Date(item.querySelector("pubDate")?.textContent).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        }),
        duration: duration,
        image: image,
        audioUrl: audioUrl,
        guid: guid || audioUrl, // Fallback to audioUrl if GUID is missing
        // This is the actual playable MP3 link
        link: item.querySelector("link")?.textContent || ""
      };
    });
  } catch (error) {
    console.error("Error parsing RSS feed:", error);
    return [];
  }
};